// import React, { useEffect } from "react";

// export default function BillPrint({
//   invoiceNo,
//   customer = {},
//   cart = [],
//   paymentType,
//   paidAmount,
//   getSubTotal = () => 0,
//   getTotalAmount = () => 0,
//   getBalance = () => 0,
//   billername,
//   created_time = null,
//   logoPath = "/logo.png",
//   logoPath1 = "/logo1.png",
//   onDone = () => {},
// }) {
//   useEffect(() => {
//     const createdDateObj = created_time ? new Date(created_time) : new Date();
//     const formattedDate = createdDateObj.toLocaleDateString("en-GB", {
//       day: "2-digit",
//       month: "2-digit",
//       year: "numeric",
//     });
//     const formattedTime = createdDateObj.toLocaleTimeString("en-GB", {
//       hour: "2-digit",
//       minute: "2-digit",
//     });

//     // Robust DOB formatter -> returns DD-MM-YYYY or empty string
//     const formatDob = (raw) => {
//       if (!raw) return "";
//       // Already DD-MM-YYYY
//       if (/^\d{2}-\d{2}-\d{4}$/.test(raw)) return raw;
//       // ISO YYYY-MM-DD -> convert
//       if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
//         const [y, m, d] = raw.split("-");
//         return `${d}-${m}-${y}`;
//       }
//       // Try Date parse for other ISO-ish formats
//       const dt = new Date(raw);
//       if (!isNaN(dt.getTime())) {
//         // toLocaleDateString('en-GB') gives dd/mm/yyyy -> replace slashes with dashes
//         return dt.toLocaleDateString("en-GB").replace(/\//g, "-");
//       }
//       // Fallback: return raw (best effort)
//       return raw;
//     };

//     const dobDisplay = formatDob(customer?.dob);

//     const totalQty = cart.reduce((s, it) => s + Number(it.quantity || 0), 0);
//     const subTotal = Number(
//       getSubTotal
//         ? getSubTotal()
//         : cart.reduce(
//             (s, it) => s + Number(it.price || 0) * Number(it.quantity || 0),
//             0
//           )
//     );
//     const netAmount = Number(getTotalAmount ? getTotalAmount() : subTotal);
//     const paid = paymentType === "Credit" ? Number(paidAmount || 0) : netAmount;
//     const balance = Number(
//       getBalance ? getBalance() : Math.max(0, netAmount - paid)
//     );

//     const chunkSize = 11;
//     let pages = [];

//     if (cart.length === 0) {
//       pages = [[]];
//     } else if (cart.length <= chunkSize) {
//       // Only one page if 12 or fewer items
//       pages = [cart];
//     } else {
//       // Split only if more than 12 items
//       for (let i = 0; i < cart.length; i += chunkSize) {
//         pages.push(cart.slice(i, i + chunkSize));
//       }
//     }

//     const generatePageHtml = (items, pageIndex) => {
//       const isLastPage = pageIndex === pages.length - 1;
//       const startIndex = pageIndex * chunkSize;

//       const rowsHtml = items
//         .map((item, idx) => {
//           const price = Number(item.price || 0);
//           const qty = Number(item.quantity || 0);
//           const amt = (price * qty).toFixed(2);
//           const name = item.product || item.name || "-";
//           return `
//           <tr>
//             <td class="col-center">${startIndex + idx + 1}</td>
//             <td>${name}</td>
//             <td class="col-center">₹${price.toFixed(2)}</td>
//             <td class="col-center">${qty}</td>
//             <td class="col-center">₹${amt}</td>
//           </tr>`;
//         })
//         .join("");

//       const emptyRowsCount = Math.max(0, chunkSize - items.length);
//       const emptyRows = Array.from({ length: emptyRowsCount })
//         .map(
//           () => `
//         <tr>
//           <td class="col-center">&nbsp;</td>
//           <td></td>
//           <td></td>
//           <td></td>
//           <td></td>
//         </tr>`
//         )
//         .join("");

//       return `
//       <div class="page">
//         <div class="header" style="margin-right:20px;">

//   <div class="logo-circle">
//     <img src="${logoPath}" alt="logo" />
//   </div>

//           <div class="title">
//            <p style="font-size:13px; margin:0 0 6px; font-weight:700; margin-right:25px;">உ</p>
// <p class="subline" style="margin-right:25px;">ஸ்ரீ பெரியாண்டவர் துணை</p>
// <h1 style="margin-right:25px;">ஸ்ரீ முருகன் ஆயுர்வேத</h1>
// <h2 style="margin-right:25px;">ஆலோசனை மையம்</h2>

//             <p class="address">142-A, அந்தியூர் மேயின் ரோடு, லட்சுமி மருத்துவமனை அருகில், பவானி - 638 301</p>
//           </div>
//         </div>

//         <div class="body">
//           <div class="info-box">
//             <div class="info-left">
//               <div><strong>Customer Name :</strong> ${
//                 customer.name || "—"
//               }</div>
//               <div><strong>Height :</strong> ${customer.height || "—"}</div>
//               <div><strong>Weight :</strong> ${customer.weight || "—"}</div>
//               <div><strong>Place :</strong> ${customer.place || "—"}</div>
//               <div><strong>DOB : </strong> ${dobDisplay || "-"}</div>
//               <div><strong>Mobile No :</strong> ${customer.mobile || "—"}</div>
//             </div>
//             <div class="info-right">
//               <div><strong>Date :</strong> ${formattedDate}</div>
//               <div><strong>Time :</strong> ${formattedTime}</div>
//               <div><strong>Bill No :</strong> ${invoiceNo || "—"}</div>
//             </div>
//           </div>

//           <div class="table-wrapper">
//             <div class="table-watermark"><img src="${logoPath1}" alt="watermark" /></div>
//             <table class="items">
//               <thead>
//                 <tr>
//                   <th style="width:6%;">S.No</th>
//                   <th style="width:54%;">Particulars</th>
//                   <th style="width:14%; text-align:center;">Rate</th>
//                   <th style="width:8%; text-align:center;">Qty</th>
//                   <th style="width:18%; text-align:center;">Amount</th>
//                 </tr>
//               </thead>
//               <tbody>${rowsHtml}${emptyRows}</tbody>
//             </table>
//           </div>

//           ${
//             isLastPage
//               ? `
//           <div class="sub-box">
//             <table class="sub-table">
//               <tr><td class="label">Sub Total</td><td class="val">₹${subTotal.toFixed(
//                 2
//               )}</td></tr>
//               <tr><td class="label">Net Amount</td><td class="val">₹${netAmount.toFixed(
//                 2
//               )}</td></tr>
//               <tr><td class="label">Paid</td><td class="val">₹${paid.toFixed(
//                 2
//               )}</td></tr>
//               ${
//                 paymentType === "Credit"
//                   ? `<tr><td class="label">Balance Due</td><td class="val">₹${balance.toFixed(
//                       2
//                     )}</td></tr>`
//                   : ""
//               }
//             </table>
//           </div>
//           <div class="totals-line">Total Qty : ${totalQty} &nbsp;&nbsp;&nbsp; Total Amount : ₹${netAmount.toFixed(
//                   2
//                 )}</div>
//           <div class="footer-note">குறிப்பு : ஒருமுறை விற்ற மருந்து திரும்ப பெறப்படமாட்டாது</div>
//           `
//               : `<div class="footer-note" style="margin-top:40px;">Page ${
//                   pageIndex + 1
//                 } of ${pages.length}</div>`
//           }

//         </div>

//          <div class="bottom-bar">📞 99408 32688 , 90801 99109    </div>
//       </div>
//       ${
//         pageIndex < pages.length - 1
//           ? `<div style="page-break-after: always;"></div>`
//           : ""
//       }

//       `;
//     };

//     const allPagesHtml = pages
//       .map((p, idx) => generatePageHtml(p, idx))
//       .join("");

//     const billContent = `
// <!doctype html>
// <html lang="ta">
// <head>
// <meta charset="utf-8" />
// <meta name="viewport" content="width=device-width,initial-scale=1" />
// <title>Invoice ${invoiceNo || ""}</title>
// <style>
//   * { box-sizing: border-box; }
//   html,body { margin:0; padding:0; height:100%; -webkit-print-color-adjust: exact; print-color-adjust: exact; font-family:"Helvetica Neue", Arial, sans-serif; background:#f4f4f4; }
// .page {
//   width: 210mm;
//   height: 287mm;
//   background: #fff;
//   box-shadow: 0 2px 8px rgba(0,0,0,0.06);
//   margin: 0 auto;
//   position: relative;
//   padding-bottom: 50px; /* leaves space above the fixed red bar */
//   overflow: hidden;
// }

// /* Header updated styles to match the first image */
// .header {
//   width: 100%;
//   background: #c8102e; /* darker vibrant red */
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   padding: 18px 12px;
//   position: relative;
// }

// .logo-circle {
//   width: 110px;
//   height: 110px;
//   border-radius: 50%;
//   background: #fff;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   overflow: hidden;
//   margin-left: 20px;
// }

// .logo-circle img {
//   width: 120px;
//   height: 120px;
//   object-fit: contain;
// }

// .title {
//   text-align: left;
//   color: #fff;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   marigin-right:20px;

// }

// .title .subline {
//   font-size: 16px;
//   font-weight: 600;
//   margin: 0;
//   text-align: center;
// }

// .title h1 {
//   font-size: 36px;
//   font-weight: 900;
//   margin: 2px 0;
//   line-height: 1.1;
//   text-align: center;
// }

// .title h2 {
//   font-size: 28px;
//   font-weight: 700;
//   margin: 0;
//   text-align: center;
// }

// .title .address {
//   font-size: 14px;
//   font-weight: 600;
//   margin-top: 6px;
//   text-align: center;
// }

// .body {
//   padding: 20px 24px 40px; /* reduce bottom padding */
//   position: relative;
// }

//   .info-box { border:1px solid rgba(0,0,0,0.2); border-radius:6px; padding:14px 18px; margin-top:8px; display:flex; align-items:flex-start; gap:18px; background:#fff; justify-content:space-between; }
//   .info-left { font-size:13.5px; line-height:1.8; flex:1 1 60%; }
//   .info-right { display:grid; gap:6px 12px; font-size:13.5px; line-height:1.8; width:220px; }

//   table.items { width:100%; border-collapse:collapse; margin-top:16px; font-size:13.5px; border:1px solid rgba(0,0,0,0.3); position:relative; }
//   table.items th, table.items td { padding:6px 8px; border:1px solid rgba(0,0,0,0.15); }
//   table.items th { font-weight:700; }
//   .col-center { text-align:center; }

//   .sub-box { margin-top:18px; display:flex; justify-content:flex-end; }
//   .sub-table { width:320px; border-collapse:collapse; font-size:13.5px; }
//   .sub-table td { padding:8px 6px; border-top:1px solid rgba(0,0,0,0.1); }
//   .sub-table .label { text-align:left; color:#222; }
//   .sub-table .val { text-align:right; font-weight:700; }

//   .totals-line { margin-top:20px; font-size:15px; font-weight:700; }
//   .footer-note {
//   margin-top: 14px;
//   font-size: 13px;
//   color: #111;
// }

// .bottom-bar {
//   background: #d81b2e;
//   color: #fff;
//   padding: 10px 8px;
//   text-align: center;
//   font-weight: 800;
//   font-size: 14px;
//   position: absolute;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   width: 100%;
//   margin: 0;
//   line-height: 1.4;
// }

//   .table-wrapper { position:relative; width:100%; display:inline-block; }
// .table-wrapper .table-watermark {
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   opacity: 0.22; /* increased visibility */
//   z-index: 0;
//   pointer-events: none;
//   filter: blur(1.3px); /* reduced blur for more clarity */
// }

// .table-wrapper .table-watermark img {
//   width: 360px;
//   height: auto;
//   display: block;
// }

//   table.items tbody tr td { position:relative; z-index:1; background:transparent; }

// @media print {
//   html, body { background: #fff; margin: 0; padding: 0; }
//   .page { width: auto; margin: 0; box-shadow: none; height: auto; overflow: visible; position: relative; }
//   @page { size: A4; margin: 6mm; }
//   .bottom-bar { position: fixed; bottom: 0; left: 0; right: 0; }
// }

// </style>
// </head>
// <body>${allPagesHtml}</body>
// </html>`;

//     const iframe = document.createElement("iframe");
//     iframe.style.position = "fixed";
//     iframe.style.width = "0";
//     iframe.style.height = "0";
//     iframe.style.border = "0";
//     iframe.style.left = "-9999px";
//     iframe.srcdoc = billContent;
//     document.body.appendChild(iframe);

//     const onLoad = () => {
//       try {
//         iframe.contentWindow.focus();
//         iframe.contentWindow.print();
//       } catch (err) {
//         console.error("Print error", err);
//       } finally {
//         setTimeout(() => {
//           if (document.body.contains(iframe)) document.body.removeChild(iframe);
//           try {
//             onDone();
//           } catch (e) {
//             console.error("onDone callback error", e);
//           }
//         }, 800);
//       }
//     };

//     iframe.addEventListener("load", onLoad);
//     return () => {
//       iframe.removeEventListener("load", onLoad);
//       if (document.body.contains(iframe)) document.body.removeChild(iframe);
//     };
//   }, [
//     invoiceNo,
//     customer,
//     cart,
//     paymentType,
//     paidAmount,
//     getSubTotal,
//     getTotalAmount,
//     getBalance,
//     billername,
//     created_time,
//     logoPath,
//     logoPath1,
//     onDone,
//   ]);

//   return null;
// }

import React, { useEffect } from "react";

export default function BillPrint({
  invoiceNo,
  customer = {},
  cart = [],
  paymentType,
  paidAmount,
  getSubTotal = () => 0,
  getTotalAmount = () => 0,
  getBalance = () => 0,
  billername,
  created_time = null,
  logoPath = "/logo.png",
  logoPath1 = "/logo1.png",
  onDone = () => {},
}) {
  useEffect(() => {
    // Use Asia/Kolkata timezone for both date and time to reflect Indian (railway) time
    const createdDateObj = created_time ? new Date(created_time) : new Date();
    const formattedDate = createdDateObj.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      timeZone: "Asia/Kolkata",
    });
    // Railway time style -> 24-hour format (HH:mm) in IST
    const formattedTime = createdDateObj.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // Use 12-hour format
      timeZone: "Asia/Kolkata",
    });

    // Robust DOB formatter -> returns DD-MM-YYYY or empty string
    const formatDob = (raw) => {
      if (!raw) return "";
      // Already DD-MM-YYYY
      if (/^\d{2}-\d{2}-\d{4}$/.test(raw)) return raw;
      // ISO YYYY-MM-DD -> convert
      if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
        const [y, m, d] = raw.split("-");
        return `${d}-${m}-${y}`;
      }
      // Try Date parse for other ISO-ish formats
      const dt = new Date(raw);
      if (!isNaN(dt.getTime())) {
        // toLocaleDateString('en-GB') gives dd/mm/yyyy -> replace slashes with dashes
        return dt.toLocaleDateString("en-GB").replace(/\//g, "-");
      }
      // Fallback: return raw (best effort)
      return raw;
    };

    const dobDisplay = formatDob(customer?.dob);

    const totalQty = cart.reduce((s, it) => s + Number(it.quantity || 0), 0);
    const subTotal = Number(
      getSubTotal
        ? getSubTotal()
        : cart.reduce(
            (s, it) =>
              s + Number(it.retail_price || 0) * Number(it.quantity || 0),
            0
          )
    );
    const netAmount = Number(getTotalAmount ? getTotalAmount() : subTotal);
    const paid = paymentType === "Credit" ? Number(paidAmount || 0) : netAmount;
    const balance = Number(
      getBalance ? getBalance() : Math.max(0, netAmount - paid)
    );

    const chunkSize = 11;
    let pages = [];

    if (cart.length === 0) {
      pages = [[]];
    } else if (cart.length <= chunkSize) {
      // Only one page if 11 or fewer items
      pages = [cart];
    } else {
      // Split only if more than chunkSize items
      for (let i = 0; i < cart.length; i += chunkSize) {
        pages.push(cart.slice(i, i + chunkSize));
      }
    }

    const generatePageHtml = (items, pageIndex) => {
      const isLastPage = pageIndex === pages.length - 1;
      const startIndex = pageIndex * chunkSize;

      const rowsHtml = items
        .map((item, idx) => {
          const price = Number(item.retail_price || 0);
          const qty = Number(item.quantity || 0);
          const amt = (price * qty).toFixed(2);
          const name = item.product || item.name || "-";
          return `
          <tr>
            <td class="col-center">${startIndex + idx + 1}</td>
            <td>${name}</td>
            <td class="col-center">₹${price.toFixed(2)}</td>
            <td class="col-center">${qty}</td>
            <td class="col-center">₹${amt}</td>
          </tr>`;
        })
        .join("");

      const emptyRowsCount = Math.max(0, chunkSize - items.length);
      const emptyRows = Array.from({ length: emptyRowsCount })
        .map(
          () => `
        <tr>
          <td class="col-center">&nbsp;</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>`
        )
        .join("");

      return `
      <div class="page">
        <div class="header" style="margin-right:20px;">

  <div class="logo-circle">
    <img src="${logoPath}" alt="logo" />
  </div>

          <div class="title">
           <p style="font-size:13px; margin:0 0 6px; font-weight:700; margin-right:25px;">உ</p>
<p class="subline" style="margin-right:25px;">ஸ்ரீ பெரியாண்டவர் துணை</p>
<h1 style="margin-right:25px;">ஸ்ரீ முருகன் ஆயுர்வேத</h1>
<h2 style="margin-right:25px;">ஆலோசனை மையம்</h2>

            <p class="address">142-A, அந்தியூர் மேயின் ரோடு, லட்சுமி மருத்துவமனை அருகில், பவானி - 638 301</p>
          </div>
        </div>

        <div class="body">
          <div class="info-box">
            <div class="info-left">
              <div><strong>Customer Name :</strong> ${
                customer.name || "—"
              }</div>
              <div><strong>Height :</strong> ${customer.height || "—"}</div>
              <div><strong>Weight :</strong> ${customer.weight || "—"}</div>
              <div><strong>Place :</strong> ${customer.place || "—"}</div>
              <div><strong>DOB : </strong> ${dobDisplay || "-"}</div>
              <div><strong>Mobile No :</strong> ${customer.mobile || "—"}</div>
            </div>
            <div class="info-right">
              <div><strong>Date :</strong> ${formattedDate}</div>
              <div><strong>Time :</strong> ${formattedTime}</div>
              <div><strong>Bill No :</strong> ${invoiceNo || "—"}</div>
            </div>
          </div>

          <div class="table-wrapper">
            <div class="table-watermark"><img src="${logoPath1}" alt="watermark" /></div>
            <table class="items">
              <thead>
                <tr>
                  <th style="width:6%;">S.No</th>
                  <th style="width:54%;">Particulars</th>
                  <th style="width:14%; text-align:center;">Rate</th>
                  <th style="width:8%; text-align:center;">Qty</th>
                  <th style="width:18%; text-align:center;">Amount</th>
                </tr>
              </thead>
              <tbody>${rowsHtml}${emptyRows}</tbody>
            </table>
          </div>

          ${
            isLastPage
              ? `
          <div class="sub-box">
            <table class="sub-table">
              <tr><td class="label">Sub Total</td><td class="val">₹${subTotal.toFixed(
                2
              )}</td></tr>
              <tr><td class="label">Net Amount</td><td class="val">₹${netAmount.toFixed(
                2
              )}</td></tr>
              <tr><td class="label">Paid</td><td class="val">₹${paid.toFixed(
                2
              )}</td></tr>
              ${
                paymentType === "Credit"
                  ? `<tr><td class="label">Balance Due</td><td class="val">₹${balance.toFixed(
                      2
                    )}</td></tr>`
                  : ""
              }
            </table>
          </div>
          <div class="totals-line">Total Qty : ${totalQty} &nbsp;&nbsp;&nbsp; Total Amount : ₹${netAmount.toFixed(
                  2
                )}</div>
          <div class="footer-note">குறிப்பு : ஒருமுறை விற்ற மருந்து திரும்ப பெறப்படமாட்டாது</div>
          `
              : `<div class="footer-note" style="margin-top:40px;">Page ${
                  pageIndex + 1
                } of ${pages.length}</div>`
          }

         
        </div>


         <div class="bottom-bar">
           <div class="contact-left">📞 99408 32688 , 90801 99109</div>
           <div class="contact-right">✉️ srimuruganayurveda@gmail.com</div>
         </div>
      </div>
      ${
        pageIndex < pages.length - 1
          ? `<div style="page-break-after: always;"></div>`
          : ""
      }

      `;
    };

    const allPagesHtml = pages
      .map((p, idx) => generatePageHtml(p, idx))
      .join("");

    const billContent = `
<!doctype html>
<html lang="ta">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width,initial-scale=1" />
<title>Invoice ${invoiceNo || ""}</title>
<style>
  * { box-sizing: border-box; }
  html,body { margin:0; padding:0; height:100%; -webkit-print-color-adjust: exact; print-color-adjust: exact; font-family:"Helvetica Neue", Arial, sans-serif; background:#f4f4f4; }
.page {
  width: 210mm;
  height: 287mm;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  margin: 0 auto;
  position: relative;
  padding-bottom: 50px; /* leaves space above the fixed red bar */
  overflow: hidden;
}

/* Header updated styles to match the first image */
.header {
  width: 100%;
  background: #c8102e; /* darker vibrant red */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px 12px;
  position: relative;
}

.logo-circle {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-left: 20px;
}

.logo-circle img {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

.title {
  text-align: left;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  marigin-right:20px;

}

.title .subline {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  text-align: center;
}

.title h1 {
  font-size: 36px;
  font-weight: 900;
  margin: 2px 0;
  line-height: 1.1;
  text-align: center;
}

.title h2 {
  font-size: 28px;
  font-weight: 700;
  margin: 0;
  text-align: center;
}

.title .address {
  font-size: 14px;
  font-weight: 600;
  margin-top: 6px;
  text-align: center;
}

.body {
  padding: 20px 24px 40px; /* reduce bottom padding */
  position: relative;
}



  .info-box { border:1px solid rgba(0,0,0,0.2); border-radius:6px; padding:14px 18px; margin-top:8px; display:flex; align-items:flex-start; gap:18px; background:#fff; justify-content:space-between; }
  .info-left { font-size:13.5px; line-height:1.8; flex:1 1 60%; }
  .info-right { display:grid; gap:6px 12px; font-size:13.5px; line-height:1.8; width:220px; }

  table.items { width:100%; border-collapse:collapse; margin-top:16px; font-size:13.5px; border:1px solid rgba(0,0,0,0.3); position:relative; }
  table.items th, table.items td { padding:6px 8px; border:1px solid rgba(0,0,0,0.15); }
  table.items th { font-weight:700; }
  .col-center { text-align:center; }

  .sub-box { margin-top:18px; display:flex; justify-content:flex-end; }
  .sub-table { width:320px; border-collapse:collapse; font-size:13.5px; }
  .sub-table td { padding:8px 6px; border-top:1px solid rgba(0,0,0,0.1); }
  .sub-table .label { text-align:left; color:#222; }
  .sub-table .val { text-align:right; font-weight:700; }

  .totals-line { margin-top:20px; font-size:15px; font-weight:700; }
  .footer-note {
  margin-top: 14px;
  font-size: 13px;
  color: #111;
}

/* Bottom bar now splits left (phone) and right (email) */
.bottom-bar {
  background: #d81b2e;
  color: #fff;
  padding: 10px 20px;
  text-align: center;
  font-weight: 800;
  font-size: 14px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  margin: 0;
  line-height: 1.4;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bottom-bar .contact-left { text-align: left; }
.bottom-bar .contact-right { text-align: right; }


  .table-wrapper { position:relative; width:100%; display:inline-block; }
.table-wrapper .table-watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.22; /* increased visibility */
  z-index: 0;
  pointer-events: none;
  filter: blur(1.3px); /* reduced blur for more clarity */
}

.table-wrapper .table-watermark img {
  width: 360px;
  height: auto;
  display: block;
}


  table.items tbody tr td { position:relative; z-index:1; background:transparent; }

@media print {
  html, body { background: #fff; margin: 0; padding: 0; }
  .page { width: auto; margin: 0; box-shadow: none; height: auto; overflow: visible; position: relative; }
  @page { size: A4; margin: 6mm; }
  .bottom-bar { position: fixed; bottom: 0; left: 0; right: 0; }
}

</style>
</head>
<body>${allPagesHtml}</body>
</html>`;

    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    iframe.style.left = "-9999px";
    iframe.srcdoc = billContent;
    document.body.appendChild(iframe);

    const onLoad = () => {
      try {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      } catch (err) {
        console.error("Print error", err);
      } finally {
        setTimeout(() => {
          if (document.body.contains(iframe)) document.body.removeChild(iframe);
          try {
            onDone();
          } catch (e) {
            console.error("onDone callback error", e);
          }
        }, 800);
      }
    };

    iframe.addEventListener("load", onLoad);
    return () => {
      iframe.removeEventListener("load", onLoad);
      if (document.body.contains(iframe)) document.body.removeChild(iframe);
    };
  }, [
    invoiceNo,
    customer,
    cart,
    paymentType,
    paidAmount,
    getSubTotal,
    getTotalAmount,
    getBalance,
    billername,
    created_time,
    logoPath,
    logoPath1,
    onDone,
  ]);

  return null;
}
